import "solid-devtools";
import "./index.css";
import { render } from "solid-js/web";
import { Route, Router } from "@solidjs/router";
import Main from "./components/layout/Main/Main.js";
import Home from "./pages/Home/Home.js";
import TermsOfUse from "./pages/Legals/TermsOfUse/TermsOfUse.js";
import CookiePolicy from "./pages/Legals/CookiePolicy/CookiePolicy.js";
import PrivacyPolicy from "./pages/Legals/PrivacyPolicy/PrivacyPolicy.js";
import NotFound from "./pages/NotFound/NotFound.js";
import { gmodRoutes } from "./packages/gmod/routes.js";

const root = document.getElementById("root");
if (import.meta.env.DEV && !(root instanceof HTMLElement)) {
  throw new Error(
    "Something went wrong. Did you forget to add the root element to your index.html? Or maybe the id attribute got misspelled?",
  );
}

render(
  () => (
    <Router root={Main}>
      <Route path="/" component={Home} />
      {/* Garry's Mod */}
      <Route path="/gmod">
        {gmodRoutes.map((route) => (
          <Route path={route.path} component={route.component} />
        ))}
      </Route>
      {/* Legals */}
      <Route path="/legals/terms-of-use" component={TermsOfUse} />
      <Route path="/legals/cookie-policy" component={CookiePolicy} />
      <Route path="/legals/privacy-policy" component={PrivacyPolicy} />
      <Route path="*" component={NotFound} />
    </Router>
  ),
  root!,
);
